import setup from "./setup"

const track = (...args) => {
  return setup().then(() => {
    window.analytics.track(...args)
    console.log("%c @analytics/segment - track", "color: #bada55", args)
  })
}

const identity = (...args) => {
  return setup().then(() => {
    window.analytics.identify(...args)
    console.log("%c @analytics/segment - identity", "color: #bada55", args)
  })
}

const page = (...args) => {
  return setup().then(() => {
    window.analytics.page(...args)
    console.log("%c @analytics/segment - page view", "color: #bada55", args)
  })
}

export default {
  track,
  identity,
  page,
}
